import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class shipperAccountLinkCtrl implements IController {
  account: AccountModel;
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountLink', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-link.html').default,
    controller: shipperAccountLinkCtrl
  });

